<template>
  <div>
    <AmFeedback
      :title="$t('isValidated.title')"
      :description="$t('isValidated.description')"
      icon="checked"
    >
      <template
        #feedback>
        <AmIcon
          :class="['is_validated--icon', ...iconClasses]"
          name="done"
          color="#fff" />
      </template>
    </AmFeedback>
  </div>
</template>

<script>
import { AmIcon } from '@appmax_npm/ds-appmax-v3'
import AmFeedback from '../../molecules/AmFeedback/AmFeedback.vue'

export default {
  name: 'IsValidated',
  components: { AmIcon, AmFeedback },
  setup() {
    const iconClasses = ['bg-appmaxPurple rounded-xl p-1 flex items-center justify-center']
    return {
      iconClasses
    }
  }
}
</script>
